import React from 'react';
import ResourceContainer from './ResourcesContainer';
import { ShelterResources } from '../data/data.js';

const Shelter = () => {
  return (
    <main>
                
      <h2>Shelters</h2>
      <ResourceContainer resources={ShelterResources} />              
    </main>
  );
}

export default Shelter;